/* Custom scripts — keep all theme JS customizations here, never in theme.js */

/*
 * [free_shipping] placeholder currency correction.
 *
 * The cart announcement's [free_shipping] amount is rendered by Liquid, which
 * cannot access the base -> presentment currency rate (JS-only). This script
 * recomputes the remaining amount exactly like Impact's FreeShippingBar does
 * (threshold in store base currency x Shopify.currency.rate, minus the cart
 * total) and rewrites the placeholder, so both always show the same number.
 * The drawer section re-renders on cart changes, so a MutationObserver
 * re-corrects any freshly rendered placeholder.
 */
(function () {
  function correct(root) {
    if (!window.Shopify || !Shopify.currency) return;
    var scope = root.querySelectorAll ? root : document;
    var rate = parseFloat(Shopify.currency.rate) || 1;
    var formatter = new Intl.NumberFormat(Shopify.locale, { style: 'currency', currency: Shopify.currency.active });

    // Counting-down variant: threshold minus current cart total
    scope.querySelectorAll('[data-free-shipping-remaining]').forEach(function (el) {
      var thresholdBase = parseFloat(el.getAttribute('data-threshold-base'));
      var cartTotal = parseFloat(el.getAttribute('data-cart-total'));
      if (isNaN(thresholdBase) || isNaN(cartTotal)) return;
      el.textContent = formatter.format(Math.max(0, Math.round(thresholdBase * rate) - cartTotal) / 100);
    });

    // Static variant: the threshold amount itself
    scope.querySelectorAll('[data-free-shipping-threshold]').forEach(function (el) {
      var thresholdBase = parseFloat(el.getAttribute('data-threshold-base'));
      if (isNaN(thresholdBase)) return;
      el.textContent = formatter.format(Math.round(thresholdBase * rate) / 100);
    });
  }

  /*
   * Quick-buy popup: optionally open the cart drawer after adding instead of
   * Impact's inline confirmation. Controlled by the "Open cart drawer after
   * quick buy" theme setting (data attribute on the cart drawer element).
   * Capture-phase listener intercepts before the popup's own variant:add
   * handler runs, so the inline confirmation never starts.
   */
  document.addEventListener('variant:add', function (event) {
    var cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer || cartDrawer.getAttribute('data-quick-buy-to-drawer') !== 'true') return;
    if (!window.themeVariables || !themeVariables.settings || themeVariables.settings.cartType !== 'drawer') return;

    var quickBuy = event.target.closest && event.target.closest('quick-buy-drawer');
    if (!quickBuy) return;

    event.stopPropagation();
    if (typeof quickBuy.hide === 'function') quickBuy.hide();
    if (typeof cartDrawer.show === 'function') cartDrawer.show();
  }, true);

  /*
   * Grey out stepper buttons at their limits: minus disabled at the variant's
   * minimum quantity, plus disabled at its maximum. The theme's own component
   * silently no-ops there, which reads as broken.
   */
  function refreshSteppers(root) {
    (root.querySelectorAll ? root : document).querySelectorAll('quantity-selector').forEach(function (sel) {
      var input = sel.querySelector('input');
      var buttons = sel.querySelectorAll('button');
      if (!input || buttons.length < 2) return;

      var value = parseFloat(input.value);
      var min = parseFloat(input.min) || 1;
      var max = input.max ? parseFloat(input.max) : Infinity;
      var atMin = value <= min;

      if (input.hasAttribute('data-line-key')) {
        // Cart line item: at the minimum the minus button becomes a remove button
        sel.classList.toggle('quantity-selector--at-min', atMin);
        buttons[0].disabled = false;
        if (atMin && sel.getAttribute('data-remove-label')) {
          buttons[0].setAttribute('aria-label', sel.getAttribute('data-remove-label'));
        }
      } else {
        buttons[0].disabled = atMin;
      }
      buttons[buttons.length - 1].disabled = value >= max;
    });
  }

  // At minimum quantity the minus button removes the line item, through the
  // theme's own LineItemQuantity logic so sections re-render as usual.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('quantity-selector button');
    if (!btn) return;

    var sel = btn.closest('quantity-selector');
    if (!sel || !sel.classList.contains('quantity-selector--at-min')) return;
    if (sel.querySelectorAll('button')[0] !== btn) return;

    var input = sel.querySelector('input[data-line-key]');
    if (!input) return;

    event.preventDefault();
    event.stopPropagation();

    var lineItemQuantity = sel.closest('line-item-quantity');
    if (lineItemQuantity && typeof lineItemQuantity._changeLineItemQuantity === 'function') {
      lineItemQuantity._changeLineItemQuantity(input.getAttribute('data-line-key'), 0);
    }
  }, true);

  ['input', 'change'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      var sel = event.target.closest && event.target.closest('quantity-selector');
      if (sel) refreshSteppers(sel.parentNode || document);
    });
  });

  function init() {
    correct(document);
    refreshSteppers(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The main announcement bar does not re-render on cart changes, so its
  // [free_shipping] amounts are refreshed from the cart:change payload here.
  document.addEventListener('cart:change', function (event) {
    var cart = event.detail && event.detail.cart;
    if (!cart || !cart.items) return;

    var total = cart.items.reduce(function (sum, item) {
      return sum + (item.requires_shipping ? item.final_line_price : 0);
    }, 0) - (cart.cart_level_discount_applications || []).reduce(function (sum, d) {
      return sum + d.total_allocated_amount;
    }, 0);

    document.querySelectorAll('[data-free-shipping-remaining]').forEach(function (el) {
      el.setAttribute('data-cart-total', total);
    });
    correct(document);
  });

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.querySelector && (node.querySelector('[data-free-shipping-remaining], [data-free-shipping-threshold]') || node.matches('[data-free-shipping-remaining], [data-free-shipping-threshold]'))) correct(node);
        if (node.querySelector && (node.querySelector('quantity-selector') || node.tagName === 'QUANTITY-SELECTOR')) refreshSteppers(node.parentNode || document);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/*
 * Header shadow on scroll: toggles .page-scrolled on <html> once the page
 * moves, letting the optional header shadow (Theme settings > Navigation &
 * header) fade in only when content sits underneath the sticky header.
 */
(function () {
  var scheduled = false;

  function apply() {
    document.documentElement.classList.toggle('page-scrolled', window.scrollY > 12);
  }

  window.addEventListener('scroll', function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      apply();
    });
  }, { passive: true });

  apply();
})();

/*
 * Star rating -> reviews scroll. The buy box rating block renders as a
 * button with [data-scroll-to-reviews]; clicking finds the first review
 * target on the page (merchant-set selector first, then common review
 * apps, then the theme's own review sections) and scrolls to it below
 * the sticky header. Delegated so it also works inside quick views.
 */
document.addEventListener('click', function (event) {
  var trigger = event.target.closest && event.target.closest('[data-scroll-to-reviews]');
  if (!trigger) return;

  var target = null;
  var custom = trigger.getAttribute('data-reviews-selector');
  if (custom) {
    try { target = document.querySelector(custom); } catch (e) { target = null; }
  }
  if (!target) {
    target = document.querySelector([
      '#judgeme_product_reviews', '.jdgm-widget',
      '#looxReviews',
      '[id^="stamped-main-widget"]',
      '.yotpo-widget-instance', '.yotpo',
      '.okeReviews',
      '#shopify-product-reviews',
      '.shopify-section--reviews-carousel',
      '.shopify-section--review-cards',
      '.shopify-section--testimonial-columns'
    ].join(', '));
  }
  if (!target) return;

  var header = document.querySelector('.shopify-section--header');
  var offset = header ? header.offsetHeight + 8 : 0;
  var top = target.getBoundingClientRect().top + window.scrollY - offset;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.scrollTo({ top: Math.max(0, top), behavior: reduced ? 'auto' : 'smooth' });
});

/*
 * Deferred ambient videos: any video rendered with class js-defer-video is
 * preload=none and has no HTML autoplay. It plays (and only then starts
 * downloading) while visible, and pauses off screen, so pages stay light
 * no matter how many videos sections contain.
 */
(function () {
  function playIt(v) {
    var attempt = function () {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    };
    /* iOS (Safari and Chrome, same WebKit) with preload=none: kick load()
       and retry once metadata arrives; an immediate play() can abort */
    if (v.readyState === 0) {
      try { v.load(); } catch (e) {}
      v.addEventListener('loadedmetadata', attempt, { once: true });
      setTimeout(attempt, 350);
      return;
    }
    attempt();
  }

  var observer = null;

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var videos = scope.querySelectorAll('video.js-defer-video');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(playIt);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) playIt(entry.target);
          else entry.target.pause();
        });
      }, { threshold: 0.25 });
    }

    videos.forEach(function (v) {
      if (v.__deferInit) return;
      v.__deferInit = true;
      observer.observe(v);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    if (!observer || !event.target.querySelectorAll) return;
    event.target.querySelectorAll('video.js-defer-video').forEach(function (v) { observer.unobserve(v); });
  });
})();

/*
 * Pause looping CSS animations while their section is off screen. Any
 * element with [data-pause-offscreen] gets .is-offscreen toggled; sections
 * opt in with a CSS rule pausing their animation under that class.
 */
(function () {
  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      entry.target.classList.toggle('is-offscreen', !entry.isIntersecting);
    });
  }, { threshold: 0 });

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-pause-offscreen]').forEach(function (el) {
      if (el.__pauseInit) return;
      el.__pauseInit = true;
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target.querySelectorAll) return;
    event.target.querySelectorAll('[data-pause-offscreen]').forEach(function (el) { observer.unobserve(el); });
  });
})();
